// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

.app-container {
  display: flex;
  min-height: 100vh;
  border: 1px solid black;
  font-family: Arial, sans-serif;
  background-color: #eaf5ff;
  position: relative;
  width: 100%;
  overflow-x: hidden;
  /* soft blue background */
}

.config-window,
.chat-window {
  display: flex;
  flex-direction: column;
  border: 1px solid #007bff;
  /* blue border */
  border-radius: 5px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.chat-window {
  flex: 1 1;

  padding: 10px;
}

.chat-messages {
  max-height: 700px;
  overflow-y: auto;
  border-radius: 5px;
  margin-bottom: 10px;
}

.user {
  align-self: flex-end;
  background-color: #e0e0e0;
  padding: 5px;
  border-radius: 5px;
  margin: 5px;
}

.chat-input {
  display: flex;
  gap: 10px;
  /* justify-content: center; */
  justify-content: space-between;
  /* Center horizontally */
  align-items: center;
  box-sizing: border-box;
  /* So t

  /* Center vertically */
}

.chat-input input {
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.input-button-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  /* Center the grouped items horizontally */
  gap: 7px;
  padding: 7px;
}

.styled-input {
  border: 1px solid #ccc;
  padding: 10px 12px;
  /* Unified vertical padding */
  border-radius: 4px;
  font-size: 16px;
  max-width: 100%;
  transition: border-color 0.2s;
  display: flex;
  box-sizing: border-box;

  /* height: 20px; */
  /* Ensure this height accommodates for the padding and text height */
}

/* When screen width is 480px or less */
@media (max-width: 370px) {
  .chat-input {
    flex-direction: column;
    /* Stack child elements vertically */
  }

  .chat-input input {
    width: 100%;
    /* Make input take full width */
  }
}

.styled-input:focus {
  border-color: #007bff;
  /* Just an example. Adjust the color as needed. */
}

.chat-input input:focus {
  border-color: #007bff;
  /* blue border on focus */
  outline: none;
}

.chat-input button {
  padding: 10px 20px;
  box-sizing: border-box;
}

.config-inputs {
  flex-direction: column;
  display: grid;
  /* width: 500px; */
  gap: 10px;
  /* To provide space between input fields */
}

.config-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.config-input label {
  width: 100px;
  font-weight: bold;
}

.config-input input,
.config-input textarea {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 180px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.config-input input:focus,
.config-input textarea:focus {
  border-color: #007bff;
  /* blue border on focus */
  outline: none;
}

/* Ensures labels have the same width */

.save-btn,
.chat-input button,
.small-btn {
  padding: 8px 20px;
  margin: 10px 0;
  background-color: #007bff;
  border: none;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 40px;
  box-sizing: border-box;
  /* So t
  /* Match this height with the input height */
}

/* Style for the smaller button */
.small-btn {
  padding: 10px 12px;
  font-size: 16px;
  background-color: #21903b;
  max-width: 100%;
  white-space: nowrap;
  /* Prevents text wrapping */
  overflow: hidden;
  /* In case the text is too long, it will be hidden */
  text-overflow: ellipsis;
  /* Display ellipsis (...) if text overflows the container */
}

.btn-container {
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  height: 50px;
  /* Set the container's height (adjust as needed) */
}

.save-btn:hover,
.chat-input button:hover {
  background-color: #0056b3;
}

/* Additional hover style for .small-btn */
.small-btn:hover {
  background-color: #19702a;
  /* darker green on hover */
}

.save-btn.highlight {
  background-color: #465c51;
  cursor: not-allowed;
  /* You can change this to any color you prefer */
}

.set-session {
  background-color: #557f9f;
  /* You can change this to any color you prefer */
}

.first-name-section {
  position: relative;
  display: flex;
  /* allows the item to shrink */
}

.error-tooltip {
  display: none;
  /* Hide by default */
  position: absolute;
  bottom: 100%;
  /* Position right above the input */
  left: 50%;
  /* Center align */
  transform: translateX(-50%);
  /* Adjust for center */
  background-color: #e74c3c;
  color: white;
  width: 120px;
  padding: 7px 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 10;
}

.first-name-section.show-tooltip .error-tooltip {
  display: block;
}

/* .error-tooltip::before {
  content: '';
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent red;
}

.show-tooltip .error-tooltip {
  display: block;
} */

/* App.css or your CSS file */
.disabled-input {
  background-color: #f2f2f2;
  /* Grey background color */
  color: #808080;
  cursor: not-allowed;
  /* Grey text color */
}

.button-select {
  /* background-color: #007BFF; */
  background-color: #251071;
  /* Blue background */
  color: white;
  cursor: pointer;
}

.button-disabled {
  background-color: grey;
  color: darkgrey;
  cursor: not-allowed;
}

.error {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}

.loading-gif {
  width: 100px;
  height: 100px;
  margin: 10px auto;
  display: block;
}

.chatMessage {
  display: flex;
  align-items: center;
  padding: 5px;
  margin: 5px 0;
}

.chatMessage img {
  width: 24px;
  /* or whatever size you prefer */
  height: 24px;
  margin-right: 10px;
}

/* Style for the settings gearbox button */
.gearbox {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 10px;
}

/* For the chat and config windows */
.config-window,
.chat-window {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  /* 50% of viewport height */
  overflow-y: auto;
  margin-top: 40px;
}

@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
    /* stack children vertically */
  }

  .gearbox {
    position: static;
    /* reset positioning */
    margin: 10px auto;
    /* center the button */
  }

  .config-window,
  .chat-window {
    margin: 5px;
    margin-top: 5px;
    /* Adjust margin for mobile view */
  }
}

/* For individual chat messages */
.assistant,
.person {
  border-bottom: 1px solid #ddd;
  padding: 0%;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.chat-icon,
.user-icon {
  color: #007bff;
  /* blue icon color */
  margin-right: 10px;
}

.circular-icon {
  width: 30px;
  /* Set the desired width */
  height: 30px;
  /* Set the desired height */
  border-radius: 50%;
  /* Create a circular shape */
  object-fit: cover;
  /* Maintain aspect ratio and cover the circle */
  overflow: hidden;
}

@media (min-width: 769px) {
  .assistant,
  .person .user-icon {
    margin-right: 10px;
  }
}

.chat-input-textarea {
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
}

.typing-dots {
  display: inline-block;
  width: 3em;
  /* Adjust the width as needed */
  text-align: center;
}

.typing-dot {
  display: inline-block;
  width: 0.4em;
  /* Adjust the dot width as needed */
  height: 0.4em;
  /* Adjust the dot height as needed */
  background-color: #333;
  /* Adjust the dot color as needed */
  margin: 0 0.2em;
  /* Adjust the spacing between dots as needed */
  border-radius: 50%;
  animation: bounce 1s infinite;
  /* Adjust animation duration as needed */
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-0.3em);
    /* Adjust the bounce height as needed */
  }
}

input,
select,
textarea {
  font-size: 16px;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.chat-input * {
  max-width: 100%;
  box-sizing: border-box;
}

.chat-input button {
  font-size: 16px;
}

.styled-input,
.save-btn {
  width: 170px;
  /* or any other width you desire */
}

.get-diagram-btn {
  display: inline-block;
  /* Makes the button inline but allows for padding and dimension adjustments */
  padding: 8px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f4f4f4;
  margin-top: 10px;
  height: 40px;
  /* Grey background */
  color: #333;
  /* Darker text */
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 170px;
}

.modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 300px;
  text-align: center;
}

/* Responsive adjustments for screens narrower than 600px */
@media (max-width: 600px) {
  .modal-content {
    width: auto;
    /* Allows the modal to expand or contract based on the screen size */
    padding: 10px;
    /* Adjust padding to ensure content fits well */
  }
}

button {
  margin: 0 5px;
}

/* Additional styles for ConfigWindow component */
/* .config-window {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 0 auto;
} */

.config-window h2 {
  text-align: center;
  margin-bottom: 15px;
}

.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tab {
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background-color: #e0e0e0;
  margin: 0 5px;
  border-radius: 4px;
}

.tab.active {
  background-color: #007bff;
  color: white;
}

/* .config-inputs {
  display: flex;
  flex-direction: column;
  gap: 10px;
} */

/* .config-input {
  display: flex;
  flex-direction: column;
  gap: 5px;
} */

/* .config-input label {
  font-weight: bold;
}

.config-input input,
.config-input textarea,
.config-input select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.config-input input:focus,
.config-input textarea:focus,
.config-input select:focus {
  border-color: #007BFF;
  outline: none;
}

.config-input .error {
  color: red;
  font-size: 12px;
} */

.buttons-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

/* .save-btn,
.get-diagram-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #007BFF;
  color: white;
  transition: background-color 0.3s ease;
} */

/* .save-btn:hover,
.get-diagram-btn:hover {
  background-color: #0056b3;
}

.save-btn:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
} */

.temperature-input {
  display: flex;
  align-items: center;
}

.temperature-controls {
  display: flex;
  align-items: center;
  gap: 5x;
}

.temperature-controls input[type="range"] {
  flex-grow: 1;
}

.temperature-controls input[type="number"] {
  width: 90px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,SAAO;;EAEP,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB;;wBAEsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,0CAA0C;EAC1C,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,+BAA+B;EACjC;AACF;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA,uCAAuC;;AAEvC;;;EAGE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;EACtB;8CAC4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,oDAAoD;EACpD,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA,oCAAoC;AACpC;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kCAAkC;EACpC;AACF;;AAEA,iCAAiC;AACjC;;EAEE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,mCAAmC;EACnC,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,uCAAuC;EACzC;AACF;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6EAA6E;EAC7E,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE;IACE,WAAW;IACX,oEAAoE;IACpE,aAAa;IACb,+CAA+C;EACjD;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;;;;;;;GAOG;;AAEH;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* App.css */\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  border: 1px solid black;\n  font-family: Arial, sans-serif;\n  background-color: #eaf5ff;\n  position: relative;\n  width: 100%;\n  overflow-x: hidden;\n  /* soft blue background */\n}\n\n.config-window,\n.chat-window {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #007bff;\n  /* blue border */\n  border-radius: 5px;\n  padding: 20px;\n  margin-top: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n\n.chat-window {\n  flex: 1;\n\n  padding: 10px;\n}\n\n.chat-messages {\n  max-height: 700px;\n  overflow-y: auto;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n\n.user {\n  align-self: flex-end;\n  background-color: #e0e0e0;\n  padding: 5px;\n  border-radius: 5px;\n  margin: 5px;\n}\n\n.chat-input {\n  display: flex;\n  gap: 10px;\n  /* justify-content: center; */\n  justify-content: space-between;\n  /* Center horizontally */\n  align-items: center;\n  box-sizing: border-box;\n  /* So t\n\n  /* Center vertically */\n}\n\n.chat-input input {\n  flex-grow: 1;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n}\n\n.input-button-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  /* Center the grouped items horizontally */\n  gap: 7px;\n  padding: 7px;\n}\n\n.styled-input {\n  border: 1px solid #ccc;\n  padding: 10px 12px;\n  /* Unified vertical padding */\n  border-radius: 4px;\n  font-size: 16px;\n  max-width: 100%;\n  transition: border-color 0.2s;\n  display: flex;\n  box-sizing: border-box;\n\n  /* height: 20px; */\n  /* Ensure this height accommodates for the padding and text height */\n}\n\n/* When screen width is 480px or less */\n@media (max-width: 370px) {\n  .chat-input {\n    flex-direction: column;\n    /* Stack child elements vertically */\n  }\n\n  .chat-input input {\n    width: 100%;\n    /* Make input take full width */\n  }\n}\n\n.styled-input:focus {\n  border-color: #007bff;\n  /* Just an example. Adjust the color as needed. */\n}\n\n.chat-input input:focus {\n  border-color: #007bff;\n  /* blue border on focus */\n  outline: none;\n}\n\n.chat-input button {\n  padding: 10px 20px;\n  box-sizing: border-box;\n}\n\n.config-inputs {\n  flex-direction: column;\n  display: grid;\n  /* width: 500px; */\n  gap: 10px;\n  /* To provide space between input fields */\n}\n\n.config-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.config-input label {\n  width: 100px;\n  font-weight: bold;\n}\n\n.config-input input,\n.config-input textarea {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 180px;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n.config-input input:focus,\n.config-input textarea:focus {\n  border-color: #007bff;\n  /* blue border on focus */\n  outline: none;\n}\n\n/* Ensures labels have the same width */\n\n.save-btn,\n.chat-input button,\n.small-btn {\n  padding: 8px 20px;\n  margin: 10px 0;\n  background-color: #007bff;\n  border: none;\n  color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  height: 40px;\n  box-sizing: border-box;\n  /* So t\n  /* Match this height with the input height */\n}\n\n/* Style for the smaller button */\n.small-btn {\n  padding: 10px 12px;\n  font-size: 16px;\n  background-color: #21903b;\n  max-width: 100%;\n  white-space: nowrap;\n  /* Prevents text wrapping */\n  overflow: hidden;\n  /* In case the text is too long, it will be hidden */\n  text-overflow: ellipsis;\n  /* Display ellipsis (...) if text overflows the container */\n}\n\n.btn-container {\n  display: flex;\n  justify-content: center;\n  /* Center horizontally */\n  align-items: center;\n  /* Center vertically */\n  height: 50px;\n  /* Set the container's height (adjust as needed) */\n}\n\n.save-btn:hover,\n.chat-input button:hover {\n  background-color: #0056b3;\n}\n\n/* Additional hover style for .small-btn */\n.small-btn:hover {\n  background-color: #19702a;\n  /* darker green on hover */\n}\n\n.save-btn.highlight {\n  background-color: #465c51;\n  cursor: not-allowed;\n  /* You can change this to any color you prefer */\n}\n\n.set-session {\n  background-color: #557f9f;\n  /* You can change this to any color you prefer */\n}\n\n.first-name-section {\n  position: relative;\n  display: flex;\n  /* allows the item to shrink */\n}\n\n.error-tooltip {\n  display: none;\n  /* Hide by default */\n  position: absolute;\n  bottom: 100%;\n  /* Position right above the input */\n  left: 50%;\n  /* Center align */\n  transform: translateX(-50%);\n  /* Adjust for center */\n  background-color: #e74c3c;\n  color: white;\n  width: 120px;\n  padding: 7px 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  z-index: 10;\n}\n\n.first-name-section.show-tooltip .error-tooltip {\n  display: block;\n}\n\n/* .error-tooltip::before {\n  content: '';\n  position: absolute;\n  right: -10px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent transparent red;\n}\n\n.show-tooltip .error-tooltip {\n  display: block;\n} */\n\n/* App.css or your CSS file */\n.disabled-input {\n  background-color: #f2f2f2;\n  /* Grey background color */\n  color: #808080;\n  cursor: not-allowed;\n  /* Grey text color */\n}\n\n.button-select {\n  /* background-color: #007BFF; */\n  background-color: #251071;\n  /* Blue background */\n  color: white;\n  cursor: pointer;\n}\n\n.button-disabled {\n  background-color: grey;\n  color: darkgrey;\n  cursor: not-allowed;\n}\n\n.error {\n  color: red;\n  font-size: 0.8em;\n  margin-top: 5px;\n}\n\n.loading-gif {\n  width: 100px;\n  height: 100px;\n  margin: 10px auto;\n  display: block;\n}\n\n.chatMessage {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  margin: 5px 0;\n}\n\n.chatMessage img {\n  width: 24px;\n  /* or whatever size you prefer */\n  height: 24px;\n  margin-right: 10px;\n}\n\n/* Style for the settings gearbox button */\n.gearbox {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 1.5rem;\n  padding: 10px;\n}\n\n/* For the chat and config windows */\n.config-window,\n.chat-window {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  margin: 10px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\n  /* 50% of viewport height */\n  overflow-y: auto;\n  margin-top: 40px;\n}\n\n@media (max-width: 768px) {\n  .app-container {\n    flex-direction: column;\n    /* stack children vertically */\n  }\n\n  .gearbox {\n    position: static;\n    /* reset positioning */\n    margin: 10px auto;\n    /* center the button */\n  }\n\n  .config-window,\n  .chat-window {\n    margin: 5px;\n    margin-top: 5px;\n    /* Adjust margin for mobile view */\n  }\n}\n\n/* For individual chat messages */\n.assistant,\n.person {\n  border-bottom: 1px solid #ddd;\n  padding: 0%;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.chat-icon,\n.user-icon {\n  color: #007bff;\n  /* blue icon color */\n  margin-right: 10px;\n}\n\n.circular-icon {\n  width: 30px;\n  /* Set the desired width */\n  height: 30px;\n  /* Set the desired height */\n  border-radius: 50%;\n  /* Create a circular shape */\n  object-fit: cover;\n  /* Maintain aspect ratio and cover the circle */\n  overflow: hidden;\n}\n\n@media (min-width: 769px) {\n  .assistant,\n  .person .user-icon {\n    margin-right: 10px;\n  }\n}\n\n.chat-input-textarea {\n  flex-grow: 1;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n  width: 100%;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.typing-dots {\n  display: inline-block;\n  width: 3em;\n  /* Adjust the width as needed */\n  text-align: center;\n}\n\n.typing-dot {\n  display: inline-block;\n  width: 0.4em;\n  /* Adjust the dot width as needed */\n  height: 0.4em;\n  /* Adjust the dot height as needed */\n  background-color: #333;\n  /* Adjust the dot color as needed */\n  margin: 0 0.2em;\n  /* Adjust the spacing between dots as needed */\n  border-radius: 50%;\n  animation: bounce 1s infinite;\n  /* Adjust animation duration as needed */\n}\n\n@keyframes bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-0.3em);\n    /* Adjust the bounce height as needed */\n  }\n}\n\ninput,\nselect,\ntextarea {\n  font-size: 16px;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n.chat-input * {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.chat-input button {\n  font-size: 16px;\n}\n\n.styled-input,\n.save-btn {\n  width: 170px;\n  /* or any other width you desire */\n}\n\n.get-diagram-btn {\n  display: inline-block;\n  /* Makes the button inline but allows for padding and dimension adjustments */\n  padding: 8px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #f4f4f4;\n  margin-top: 10px;\n  height: 40px;\n  /* Grey background */\n  color: #333;\n  /* Darker text */\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  width: 170px;\n}\n\n.modal {\n  position: fixed;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  width: 300px;\n  text-align: center;\n}\n\n/* Responsive adjustments for screens narrower than 600px */\n@media (max-width: 600px) {\n  .modal-content {\n    width: auto;\n    /* Allows the modal to expand or contract based on the screen size */\n    padding: 10px;\n    /* Adjust padding to ensure content fits well */\n  }\n}\n\nbutton {\n  margin: 0 5px;\n}\n\n/* Additional styles for ConfigWindow component */\n/* .config-window {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  margin: 0 auto;\n} */\n\n.config-window h2 {\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.tabs {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.tab {\n  padding: 10px 20px;\n  cursor: pointer;\n  border: none;\n  background-color: #e0e0e0;\n  margin: 0 5px;\n  border-radius: 4px;\n}\n\n.tab.active {\n  background-color: #007bff;\n  color: white;\n}\n\n/* .config-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n} */\n\n/* .config-input {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n} */\n\n/* .config-input label {\n  font-weight: bold;\n}\n\n.config-input input,\n.config-input textarea,\n.config-input select {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n.config-input input:focus,\n.config-input textarea:focus,\n.config-input select:focus {\n  border-color: #007BFF;\n  outline: none;\n}\n\n.config-input .error {\n  color: red;\n  font-size: 12px;\n} */\n\n.buttons-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n/* .save-btn,\n.get-diagram-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  background-color: #007BFF;\n  color: white;\n  transition: background-color 0.3s ease;\n} */\n\n/* .save-btn:hover,\n.get-diagram-btn:hover {\n  background-color: #0056b3;\n}\n\n.save-btn:disabled {\n  background-color: #e0e0e0;\n  cursor: not-allowed;\n} */\n\n.temperature-input {\n  display: flex;\n  align-items: center;\n}\n\n.temperature-controls {\n  display: flex;\n  align-items: center;\n  gap: 5x;\n}\n\n.temperature-controls input[type=\"range\"] {\n  flex-grow: 1;\n}\n\n.temperature-controls input[type=\"number\"] {\n  width: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
